export const ENTERPRISE_IDENTITY_REMOVE_FROM_WORKSPACE_INFO =
  "Users provisioned via Directory Sync may be re-added on the next sync if they remain in a mapped IdP group. Remove them from the IdP group to permanently revoke access.";

export const ENTERPRISE_IDENTITY_LEAVE_WORKSPACE_INFO =
  "You may be re-added on the next Directory Sync if you remain in a mapped IdP group.";
